module.exports = __webpack_public_path__ + "img/desktop-register.da93f826.svg";